import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgThumbDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21 15C20.4333 15 19.9583 14.8083 19.575 14.425C19.1917 14.0417 19 13.575 19 13.025V5C19 4.45 19.1957 3.979 19.587 3.587C19.979 3.19567 20.45 3 21 3C21.5667 3 22.0417 3.19167 22.425 3.575C22.8083 3.95833 23 4.425 23 4.975V13C23 13.55 22.8043 14.0207 22.413 14.412C22.021 14.804 21.55 15 21 15ZM10.875 21.95C10.5917 22.2333 10.2417 22.375 9.825 22.375C9.40833 22.375 9.05833 22.2333 8.775 21.95C8.59167 21.7667 8.46233 21.554 8.387 21.312C8.31233 21.0707 8.3 20.825 8.35 20.575L9.3 16H3C2.46667 16 2 15.8 1.6 15.4C1.2 15 1 14.5333 1 14V12C1 11.8833 1.01267 11.7583 1.038 11.625C1.06267 11.4917 1.1 11.3667 1.15 11.25L4.175 4.2C4.35833 3.8 4.63767 3.5 5.013 3.3C5.38767 3.1 5.775 3 6.175 3H15C15.55 3 16.021 3.19567 16.413 3.587C16.8043 3.979 17 4.45 17 5V15C17 15.2667 16.95 15.5207 16.85 15.762C16.75 16.004 16.6083 16.2167 16.425 16.4L10.875 21.95ZM15 5H6L3 12V14H12L10.65 19.35L15 15V5Z",
		fill: "currentColor"
	})
});
export default SvgThumbDown;
